// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/InviteYourColleagueForm/Handlers/SetFieldValue";
import { InviteYourColleagueFormContext } from "@store/Library/Widgets/InviteYourColleague/InviteYourColleagueForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    fieldLabel = "fieldLabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.fieldLabel]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    firstNameState: state.greif.components.inviteYourColleagueForm.fieldValues["firstName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface FirstNameStyles {
    firstNameTextField?: TextFieldPresentationProps;
}

export const firstNameStyles: FirstNameStyles = {};

const styles = firstNameStyles;

const FirstName: FC<Props> = ({ fields, firstNameState, setFieldValue }) => {
    const { isRequired, fieldLabel } = fields;
    const inviteYourColleagueFormContext = useContext(InviteYourColleagueFormContext);
    const [firstNameErrorMessage, setFirstNameErrorMessage] = useState("");
    const [firstName, setFirstName] = useState("");
    const [hasValidated, setHasValidated] = useState(false);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.firstName = validateFirstName;
    }, [firstName]);

    useEffect(() => {
        if (hasValidated) {
            validateFirstName();
        }
    }, [firstName, hasValidated]);

    useEffect(() => {
        setFirstName(firstNameState as string);
    }, [firstNameState]);

    useEffect(() => {
        inviteYourColleagueFormContext.validators.firstName = validateFirstName;
    }, [isRequired]);

    const validateFirstName = (value: string = firstName) => {
        setHasValidated(true);
        const errorMessage = isRequired && !value ? siteMessage("Field_Required", fieldLabel).toString() : "";
        setFirstNameErrorMessage(errorMessage);
        return !errorMessage;
    };

    const firstNameChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setFirstName(event.target.value);
        if (hasValidated) {
            validateFirstName(event.target.value);
        }
    };

    const firstNameChangeOnBlur = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "firstName", value: event.target.value });
    };

    return (
        <TextField
            label={fieldLabel}
            value={firstName || ""}
            onChange={firstNameChangeHandler}
            required={isRequired}
            error={firstNameErrorMessage}
            onBlur={firstNameChangeOnBlur}
            data-test-selector="first-name-input"
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(FirstName),
    definition: {
        displayName: "First Name",
        group: constants.widgetGroup.inviteYourColleague,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.inviteYourColleague, constants.pageType.notificationPreferences],
        fieldDefinitions: [
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.fieldLabel,
                displayName: "Field Label",
                editorTemplate: "TextField",
                defaultValue: "Your Colleague's First Name",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
